import { Box, Button } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useTrainingFormsDatatable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { translateFormType } from '../../../../../lib/trainingFormTypes'
import { Actions } from './Actions'
import { statusFilter } from './Filters/StatusFilter'
import { typeFilter } from './Filters/TypeFilter'
import { FormStatusTag } from './FormStatusTag'

export const AllFormsDatatable = ({ trainingId }: { trainingId: number }) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const { navigation } = useNavigation()
  const source = useTrainingFormsDatatable(
    [
      {
        identifier: 'surveyName',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.surveys.all_forms_datatable.column_name'),
        template: '{{surveyName}}',
        render: ({ title }) => {
          return title
        },
        colSpan: 6,
      },
      {
        identifier: 'status',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.surveys.status.column_title'),
        template: '{{status}}',
        render: ({ status }) => {
          if (status) return <FormStatusTag formStatus={status} />
        },
        colSpan: 2,
      },
      {
        identifier: 'type',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.surveys.type.column_title'),
        sortBy: 'formType',
        template: '{{type}}',
        render: ({ formType }) => {
          return translateFormType(formType)
        },
        colSpan: 2,
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        render: ({ id, status }) => {
          return (
            <Box flexDirection="row" gap="s4" justifyContent="flexEnd">
              <PopoverMenu type="list">
                <PopoverMenu.Trigger>
                  <Button type="secondary" iconName="ellipsis" />
                </PopoverMenu.Trigger>
                <PopoverMenu.Content side="bottom" align="end">
                  <>
                    <PopoverMenu.RouterOption
                      title={i18n.t('trainings.trainings_table.delete')}
                      to={{
                        pathname:
                          navigation.trainings.list.details_revamp.view.surveys.delete.fullPath({
                            id: trainingId,
                            formId: id,
                          }),
                      }}
                      danger
                      disabled={status !== 'draft'}
                    />
                  </>
                </PopoverMenu.Content>
              </PopoverMenu>
              <Button.Router
                type="secondary"
                to={navigation.trainings.list.details_revamp.trainingSurveyDetail.questions.fullPath(
                  {
                    id: trainingId,
                    formId: id,
                  }
                )}
                iconName="arrow-right"
              />
            </Box>
          )
        },
      },
    ],
    {
      variables: {
        resourceId: trainingId.toString(),
        search: debouncedSearch,
      },
    }
  )

  const filters = [typeFilter(source), statusFilter(source)]
  return (
    <DataTable
      source={source}
      disableExport
      filters={filters}
      disableEditColumns
      search={{ onChange: onSearch, value: search, placeholder: '' }}
      actions={<Actions trainingId={trainingId} />}
    />
  )
}
